import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./DahsboardAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* getUserProfileRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const response = yield call(api.getCountriesData);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* categoriesDashboardRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.categoriesDashboard, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* curriculumDashboardRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.curriculumDashboard, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* DashboardWatcherSaga() {
  yield takeLatest(
    actionTypes.DASHBOARD_ACTION_GET_NEW_DATA,
    getUserProfileRequestSaga
  );

  yield takeLatest(
    actionTypes.CATEGORIES_DASHBOARD_REQUEST,
    categoriesDashboardRequestSaga
  );

  yield takeLatest(
    actionTypes.CURRICULUM_DASHBOARD_REQUEST,
    curriculumDashboardRequestSaga
  );
}
